export default __webpack_public_path__ + "static/media/tete31.1281392e.png";